import axios from 'axios'

export const httpClient = axios.create({
  baseURL: 'http://hellosanbox.com/rest-api/index.php/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
})
